import { defineComponent as S, useAttrs as V, ref as o, computed as n, onUpdated as C, openBlock as r, createElementBlock as i, normalizeClass as g, unref as z, renderSlot as _, toDisplayString as I, createCommentVNode as k, createElementVNode as A, mergeProps as B } from "vue";
import { SliderSize as E, getSliderStyleClasses as N, getSliderInputSizeClasses as w } from "./novoui-vuejs71.js";
const $ = {
  key: 0,
  class: "slider-label"
}, T = ["value", "data-testid", "disabled", "readonly"], R = /* @__PURE__ */ S({
  inheritAttrs: !1,
  __name: "NSlider",
  props: {
    label: { default: void 0 },
    modelValue: { default: 0 },
    size: { default: E.medium },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    dataTestid: { default: void 0 }
  },
  emits: [
    /**
     * Emits the updated value (event.target) after the slider just changed it
     */
    "update:modelValue"
  ],
  setup(m, { emit: p }) {
    const c = p, l = m, { class: v, value: U, modelValue: D, ...f } = V(), s = o(), t = o(l.modelValue), d = o(!0), u = n(() => ({
      value: t.value === -1 ? l.modelValue : t.value,
      width: s.value ? s.value.offsetWidth : 0
    }));
    function b(e) {
      const a = e.target;
      d.value = !1, t.value = parseInt(a == null ? void 0 : a.value), c("update:modelValue", a.value);
    }
    C(() => {
      d.value && (t.value = -1), d.value = !0;
    });
    const y = n(() => N(l)), h = n(() => w(l.size));
    return (e, a) => (r(), i("label", {
      class: g(["slider", [y.value, z(v)]])
    }, [
      _(e.$slots, "label", {}, () => [
        e.label && e.label.trim() ? (r(), i("span", $, I(e.label), 1)) : k("", !0)
      ]),
      A("input", B({
        type: "range",
        onInput: b,
        ref_key: "sliderElement",
        ref: s,
        value: u.value.value,
        class: [h.value],
        "data-testid": e.dataTestid,
        style: `--value: ${u.value.value}; --width: ${u.value.width}px`
      }, f, {
        disabled: l.disabled,
        readonly: l.readonly
      }), null, 16, T)
    ], 2));
  }
});
export {
  R as default
};
